import { LabelWrapper } from "./styled"

const Label = ({ children, className, required = false, ...props }) => {
    return (
        <LabelWrapper>
            <label className={`text-black s-16 medium ${className}`} {...props}>{children}</label>
            {
                required &&
                <span className="ml-5 text-red s-16 no-wrap">*</span>
            }
        </LabelWrapper>
    )
}

export default Label